// Apeluri de follow/unfollow folosite de toate suprafețele sociale.
//
// Fiecare apel reușit emite evenimentul global `followUpdated` (cu action
// 'follow' | 'unfollow' și userId), pe care îl ascultă FollowPreviewCard ca să
// se reîncarce — componentele nu au un store comun, deci ăsta e canalul lor.

const apiUrl = process.env.REACT_APP_API_URL;

async function parseJson(response) {
  const contentType = response.headers.get('content-type') || '';

  if (!contentType.includes('application/json')) {
    throw new Error('Serverul nu a returnat un raspuns valid.');
  }

  return response.json();
}

function notifyFollowUpdated(action, userId) {
  window.dispatchEvent(
    new CustomEvent('followUpdated', {
      detail: { action, userId },
    })
  );
}

export async function followUser(userId) {
  const response = await fetch(`${apiUrl}/user/follow/${userId}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  const data = await parseJson(response);

  if (!response.ok) {
    throw new Error(data?.message || 'Nu s-a putut urmari utilizatorul.');
  }

  notifyFollowUpdated('follow', userId);

  return data;
}

export async function unfollowUser(userId) {
  const response = await fetch(`${apiUrl}/user/follow/${userId}`, {
    method: 'DELETE',
    credentials: 'include',
  });

  const data = await parseJson(response);

  if (!response.ok) {
    throw new Error(data?.message || 'Nu s-a putut anula urmarirea.');
  }

  notifyFollowUpdated('unfollow', userId);

  return data;
}
